import { isSsr, inIframe } from './Utilities';
import { getQueryParams } from '@/utilities/Url';
import { MetricData } from './../store/modules/global/state';
import store from '@/store/index';

interface EventData {
  type: string;
  action: string;
  uri: string;
  campaignId: number;
  // eslint-disable-next-line @typescript-eslint/ban-types
  data?: object;
}

export interface IframeEventData {
  action: string;
  data: string;
  type: string;
}

interface NoFlowPageEvent {
  winner: boolean;
  metricData: MetricData;
  registrationId?: number;
  bulkPrize?: {
    code?: string | number;
    value?: string | number;
  };
}

interface GameStateEvent {
  winner: boolean;
  metricData: MetricData;
  registrationId?: number;
  bulkPrize?: {
    code?: string | number;
    value?: string | number;
  };
}

let sentNoFlowPageStatusEvent = false;
let sentGameStateEvent = false;

// eslint-disable-next-line @typescript-eslint/ban-types
export const sendEvent = (action: string, data?: object, topLevel?: boolean) => {
  if (isSsr()) {
    return;
  }

  topLevel = topLevel || false;
  const campaignState = store.getters['campaign/state'];

  const eventData: EventData = {
    type: 'leadfamly-campaign',
    action: action,
    uri: window.location.href,
    campaignId: Number(campaignState.id),
    ...(data && { data })
  };

  const windowTarget = topLevel ? window.top : window.parent;

  if (windowTarget && inIframe()) {
    // nosem: javascript.browser.security.wildcard-postmessage-configuration.wildcard-postmessage-configuration
    windowTarget.postMessage(JSON.stringify(eventData), '*');
  }
};

export const onEvent = <T>(action: string, callback: (data: T) => void) => {
  const listener = (e: MessageEvent) => {
    let data: IframeEventData;

    try {
      data = JSON.parse(e.data);

      if (data.action === action) {
        callback(e.data);
      }
      // eslint-disable-next-line no-empty
    } catch (e) {}
  };

  window.addEventListener('message', listener);

  return () => {
    window.removeEventListener('message', listener);
  };
};

export const onEventOnce = <T>(action: string, callback: (data: T) => void) => {
  const listener = onEvent<T>(action, (data) => {
    listener();
    callback(data);
  });
};

export const sendGameStateEvent = () => {
  const won = store.getters['global/isGameWinner'];
  const flowRegistrationInfo = store.getters['global/flowRegistrationInfo'];
  const params = getQueryParams();

  if (!sentGameStateEvent && won !== null && (flowRegistrationInfo?.id || params['send-game-event'])) {
    sentGameStateEvent = true;

    const replacementTags = store.getters['global/replacementTags'];

    const eventData: GameStateEvent = {
      winner: won,
      metricData: store.getters['global/getMetricData'],
      registrationId: flowRegistrationInfo?.id
    };

    if (replacementTags.bulk_prize_value) {
      eventData.bulkPrize = eventData.bulkPrize ?? {};
      eventData.bulkPrize.code = replacementTags.bulk_prize_value;
    }

    if (replacementTags.bulk_prize_value) {
      eventData.bulkPrize = eventData.bulkPrize ?? {};
      eventData.bulkPrize.value = replacementTags.bulk_prize_value;
    }

    sendEvent('game-state', eventData);
  }
};

export const sendNoFlowPageStatusEvent = () => {
  const won = store.getters['global/isGameWinner'];
  const flowRegistrationInfo = store.getters['global/flowRegistrationInfo'];

  if (!sentNoFlowPageStatusEvent && won !== null) {
    sentNoFlowPageStatusEvent = true;
    const replacementTags = store.getters['global/replacementTags'];

    const eventData: NoFlowPageEvent = {
      winner: won,
      metricData: store.getters['global/getMetricData'],
      ...(flowRegistrationInfo?.id && { registrationId: flowRegistrationInfo.id })
    };

    if (replacementTags.bulk_prize_value) {
      eventData.bulkPrize = eventData.bulkPrize ?? {};
      eventData.bulkPrize.code = replacementTags.bulk_prize_value;
    }

    if (replacementTags.bulk_prize_value) {
      eventData.bulkPrize = eventData.bulkPrize ?? {};
      eventData.bulkPrize.value = replacementTags.bulk_prize_value;
    }

    sendEvent('no-flow-page', eventData);
  } else {
    sendEvent('no-flow-page', {});
  }
};
